import(/* webpackMode: "eager" */ "/root/Flare-Backoffice-Nextjs/app/(site)/privacy/privacy.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Flare-Backoffice-Nextjs/app/components/landing/LandingFooter.jsx");
